export default __webpack_public_path__ + "static/media/AktivGrotesk-Bold.c4e27ea6.ttf";